<template>
  <div class="node" :class="[selected(), node.name] | kebab">
    <div class="title">{{node.data.title?node.data.title:node.name}}
    </div>
    <div class="subtitle">{{node.data.title?node.name:''}}</div>

    <!-- Outputs-->
    <div class="output" v-for="output in outputs()" :key="output.key">
      <div class="output-title">{{output.name}}</div>
      <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
    </div>

    <!-- Controls-->
    <div class="control" v-for="control in controls()" :key="control.key" v-control="control"></div>

    <!-- Inputs-->
    <div class="input" v-for="input in inputs()" :key="input.key">
      <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
      <div class="input-title" v-show="!input.showControl()">{{input.name}}</div>
      <div class="input-control" v-show="input.showControl()" v-control="input.control"></div>
    </div>
  </div>
</template>

<script>
  import VueRenderPlugin from 'rete-vue-render-plugin';

  export default {
    name: 'CustomNodeComponent',
    props: { },
    mixins: [ VueRenderPlugin.mixin ],
    components: {
      Socket: VueRenderPlugin.Socket
    },
    mounted () { 
    },

  }
</script>

<style>


  /* Rete customization */
  .node {
    background: rgba(192, 192, 192, 0.7);
    border: 2px solid #4B4B4B;
    border-radius: 10px;
    cursor: pointer;
    min-width: 180px;
    height: auto;
    padding-bottom: 6px;
    box-sizing: content-box;
    position: relative;
  }
  .node:hover {
    background: rgba(192, 192, 192, 0.8);
  }
  .node.selected {
    border-color: #FFD200;
  }


  .node .title {
    color: #4B4B4B;
    font-family: sans-serif;
    font-size: 18px;
    padding: 8px;
  }


  .node .subtitle {
    color: #808080;
    font-family: sans-serif;
    font-size: 14px;
    padding: 0px 8px;
  }

  .node .input-title, .node .output-title {
    vertical-align: middle;
    color: #4B4B4B;
    display: inline-block;
    font-family: sans-serif;
    font-size: 14px;
    margin: 6px;
    line-height: 24px;
  }

  .node .output {
    text-align: right;
  }

  .node .control-input {
    padding: 6px 18px;
  }

  .node .input {
    text-align: left;
  }

  .node select {
    width: 183px;
    border-radius: 30px;
    background-color: white;
    padding: 3px 2px;
    border: 1px solid #999;
    font-size: 100%;
  }

  .socket{
    background: #51A7DD !important;
  }

  .node .plot-preview {
    border: 1px solid rgba(192, 192, 192, 0.7);
  }

  .node .plot-preview:hover {
    border: 1px solid #4B4B4B;
  }

  .main-path{
      stroke: #51A7DD !important;
  }

  .node .title, .node .output-title, .node .input-title{
    color: #4B4B4B;
  }

  .context-menu .item, .context-menu .subitems, .context-menu .subitem, .context-menu .search {
    background-color: rgba(81, 167, 221, 0.8) !important;
    border-bottom: 1px solid rgba(39, 79, 119, 0.8) !important;
  }

  .hasSubitems.item::after{
    content: '>' !important;
  }

  .inline-comment{
    background: #79BAE7 !important;
    border: 3px solid #79BAE7 !important;
  }
    
  .frame-comment{
    /*background: rgba(188, 221, 242, 0.8) !important;*/
    border: 3px solid #BCDDF2 !important;
    color: #4B4B4B !important;
    font-weight: bold;
  }

  .inline-comment:focus, .frame-comment:focus{
    border: 5px solid #FFD200 !important;
  }


</style>
